var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-table",
    {
      attrs: {
        data: _vm.complaintTableData,
        loading: _vm.complaintLoading,
        "element-loading-text": "正在加载中～",
        "max-height": "400",
      },
      scopedSlots: _vm._u([
        {
          key: "tools",
          fn: function () {
            return [
              _c("span", { staticClass: "color-333 font-weight font-16" }, [
                _vm._v("投诉情况"),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("el-table-column", {
        attrs: { align: "center", prop: "complaintNo", label: "编号" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "span",
                  {
                    staticClass: "color-mainColor pointer",
                    on: {
                      click: function ($event) {
                        return _vm.handleDetail(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.complaintNo))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "orderNo", label: "投诉订单" },
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "createTime", label: "投诉时间" },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "remark",
          label: "投诉内容",
          width: "200",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "statusName", label: "处理状态" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }